import styles from './Documents.module.css';

import SearchBar from '../../../components/SearchBar/SearchBar';

import Dynamic from '../../../components/DynamicTable/DynamicTable';
import { useDispatch } from 'react-redux';
import { openModal } from '../../../redux/slices/modalSlice';
import { useState } from 'react';
import PaginationTable from '../../../components/PaginationTable/PaginationTable';

import { RiFileTextLine } from 'react-icons/ri';

const data = [
  {
    _id: '1',
    title: 'Accounts',
    uploadedBy: 'Staff 1',
    actions: ['Edit', 'Delete'],
  },
  {
    _id: '2',
    title: 'Accounts',
    uploadedBy: 'Staff 1',
    actions: ['Edit', 'Delete'],
  },
  {
    _id: '3',
    title: 'Accounts',
    uploadedBy: 'Staff 1',
    actions: ['Edit', 'Delete'],
  },
  {
    _id: '4',
    title: 'Accounts',
    uploadedBy: 'Staff 1',
    actions: ['Edit', 'Delete'],
  },
];

function Documents() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const getColumnData = (data) => {
    return data?.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        document: (
          <div className={styles.documentCell}>
            <input
              type="checkbox"
              style={{ width: '14px', height: '14px' }}
              checked={isChecked}
              onChange={(e) => {
                const checked = e.target.checked;
                setSelectedIds((prev) =>
                  checked
                    ? [...prev, item._id]
                    : prev.filter((id) => id !== item._id)
                );
              }}
            />
            <div className={styles.iconWrapper}>
              <RiFileTextLine className={styles.fileIcon} />
            </div>
            <span className={styles.titleText}>{item.title}</span>
          </div>
        ),
        uploadedBy: (
          <span className={styles.Grey_Color}>{item.uploadedBy}</span>
        ),
      };
    });
  };

  const displayData = getColumnData(data);

  const headingsData = [
    {
      title: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <input
            type="checkbox"
            style={{ width: '14px', height: '14px' }}
            checked={selectedIds.length === data.length}
            onChange={(e) => {
              const checked = e.target.checked;
              setSelectedIds(checked ? data.map((d) => d._id) : []);
            }}
          />
          Document Name
        </div>
      ),
      accessor: 'document',
    },
    {
      title: 'Uploaded By',
      accessor: 'uploadedBy',
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        {/* Status boxes */}

        {/* Search and Filters */}
        <div className={styles.totalstudentcard}>
          <div className={styles.studentsection}>
            <div className={styles.search}>
              <SearchBar
                placeholder="Search by student name"
                onChange={(e) => console.log(e.target.value)}
              />
            </div>
          </div>

          {/* Student Data Table */}
          <div>
            <div className={styles.dynamicdata}>
              <Dynamic
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Documents;
